import React from 'react';
import { ArrowRightIcon, HelpCircleIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueCard } from '../story/DialogueCard';
import { ChipGroup } from '../story/ChipGroup';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { signalCheckCards } from '../../data/tools';
import { AMARA_MENTOR } from '../../data/speakers';
export function SignalCheckScreen() {
  const {
    state,
    dispatch,
    announce
  } = useDemo();
  const values = state.fieldGuideSelections.signalCheck;
  const status = state.fieldGuideSelections.signalCheckStatus;
  return <ScreenContainer data-id="element-272" data-mp="7d4ik2qnzwh3">
      <ScreenHeading eyebrow="Day 2 tool" data-id="element-273" data-mp="7aqmbqk90e7y">Signal / Static Check</ScreenHeading>
      <div className="mt-5 max-w-2xl" data-id="element-274" data-mp="2e3aymdkg5ja5">
        <DialogueCard line={{
        kind: 'speech',
        speaker: AMARA_MENTOR,
        text: 'My alarm can be real and still need more facts.'
      }} data-id="element-275" data-mp="2947sepsqd70l" />
      </div>
      <p className="mt-4 max-w-prose text-ink/80" data-id="element-276" data-mp="2ekaxi7b6vqxv">Pick what fits. You do not have to fill in every card.</p>

      <div className="mt-6 grid gap-4 md:grid-cols-2" data-id="element-277" data-mp="2il4lf0omt5qr">
        {signalCheckCards.map((card, index) => {
        const value = values[card.id];
        const isGuess = Boolean(value && card.guessOptions?.includes(value));
        return <ChipGroup key={card.id} legend={`${index + 1}. ${card.question}`} options={card.options} value={value} onSelect={option => {
          dispatch({
            type: 'SET_TOOL_FIELD',
            tool: 'signalCheck',
            field: card.id,
            value: option
          });
          if (card.guessOptions?.includes(option) && value !== option) announce('A guess, not a proven fact.');
        }} data-id="element-278" data-mp="2x9rcfznmflxt" data-mpi={index}>
              {isGuess && <p className="anim-enter mt-3 inline-flex items-center gap-2 rounded-full bg-sand px-3 py-1.5 text-sm font-bold text-forest" data-id="element-279" data-mp="1gv9834rymbrk">
                  <HelpCircleIcon size={16} aria-hidden="true" data-id="element-280" data-mp="2k6y7xusydb43" />
                  A guess, not a proven fact.
                </p>}
            </ChipGroup>;
      })}
      </div>

      <p role="status" className="mt-5 text-sm text-ink/80" data-id="element-281" data-mp="2t7mlkoefp9gg">
        {status === 'kept' ? 'Kept for this visit.' : status === 'blank' ? 'Left blank. That is a valid choice.' : ''}
      </p>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-282" data-mp="333zhlsxgbzed">
        <Button variant="secondary" onClick={() => {
        dispatch({
          type: 'SET_TOOL_STATUS',
          tool: 'signalCheck',
          status: 'blank'
        });
        announce('Left blank. That is a valid choice.');
      }} data-id="element-283" data-mp="2y5y03cfoc850">
          Leave it blank
        </Button>
        <Button variant="secondary" onClick={() => {
        dispatch({
          type: 'SET_TOOL_STATUS',
          tool: 'signalCheck',
          status: 'kept'
        });
        announce('Kept for this visit.');
      }} data-id="element-284" data-mp="37y3okc6pw7fg">
          Keep this card for this visit
        </Button>
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'wateringMap'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-286" data-mp="99tuzqz4l6td" />} data-id="element-285" data-mp="4aqqc7n252lx">
          Open the Watering Hole Map
        </Button>
      </ActionRow>
    </ScreenContainer>;
}